import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse, AxiosHeaders } from 'axios'
import { getMergedHeaders, StringMap } from './utils'
import { reapitConnectBrowserSession } from '@reapit-sales/reapit-connect'

const apiURL = process.env.GLOBAL_REAPIT_SALES_API_V3_URL

export const apiClient: AxiosInstance = axios.create({
  baseURL: apiURL,
})

const baseHeaders: Record<string, string> = {
  'reapit-api-version': '1',
}

// Request interceptor
apiClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const existingHeaders = config.headers.toJSON() as StringMap

    const mergedHeaders: StringMap | null = await getMergedHeaders(reapitConnectBrowserSession, existingHeaders)
    if (mergedHeaders && baseHeaders) {
      config.headers = new AxiosHeaders({
        ...baseHeaders,
        ...mergedHeaders,
      })
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Response interceptor
apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error) => {
    // To do: handle response errors
    return Promise.reject(error)
  },
)
